import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\UpdateImportController::__invoke
* @see app/Http/Controllers/Import/UpdateImportController.php
* @route '/api/import/{import}'
*/
const UpdateImportController = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateImportController.url(args, options),
    method: 'put',
})

UpdateImportController.definition = {
    methods: ["put"],
    url: '/api/import/{import}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Import\UpdateImportController::__invoke
* @see app/Http/Controllers/Import/UpdateImportController.php
* @route '/api/import/{import}'
*/
UpdateImportController.url = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { import: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { import: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            import: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: typeof args.import === 'object'
        ? args.import.id
        : args.import,
    }

    return UpdateImportController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\UpdateImportController::__invoke
* @see app/Http/Controllers/Import/UpdateImportController.php
* @route '/api/import/{import}'
*/
UpdateImportController.put = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateImportController.url(args, options),
    method: 'put',
})

export default UpdateImportController